/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Select_BothInputs */

const en_deep_match_select_both = /** @type {(inputs: Deep_Match_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select both a job and a resume to analyze.`)
};

const de_deep_match_select_both = /** @type {(inputs: Deep_Match_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select both a job and a resume to analyze.`)
};

const fr_deep_match_select_both = /** @type {(inputs: Deep_Match_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select both a job and a resume to analyze.`)
};

const es_deep_match_select_both = /** @type {(inputs: Deep_Match_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select both a job and a resume to analyze.`)
};

const it_deep_match_select_both = /** @type {(inputs: Deep_Match_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select both a job and a resume to analyze.`)
};

const nl_deep_match_select_both = /** @type {(inputs: Deep_Match_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select both a job and a resume to analyze.`)
};

const pl_deep_match_select_both = /** @type {(inputs: Deep_Match_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select both a job and a resume to analyze.`)
};

const fi_deep_match_select_both = /** @type {(inputs: Deep_Match_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select both a job and a resume to analyze.`)
};

const da_deep_match_select_both = /** @type {(inputs: Deep_Match_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select both a job and a resume to analyze.`)
};

const sv_deep_match_select_both = /** @type {(inputs: Deep_Match_Select_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select both a job and a resume to analyze.`)
};

/**
* | output |
* | --- |
* | "Select both a job and a resume to analyze." |
*
* @param {Deep_Match_Select_BothInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_select_both = /** @type {((inputs?: Deep_Match_Select_BothInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Select_BothInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_select_both(inputs)
	if (locale === "fr") return fr_deep_match_select_both(inputs)
	if (locale === "es") return es_deep_match_select_both(inputs)
	if (locale === "it") return it_deep_match_select_both(inputs)
	if (locale === "nl") return nl_deep_match_select_both(inputs)
	if (locale === "pl") return pl_deep_match_select_both(inputs)
	if (locale === "fi") return fi_deep_match_select_both(inputs)
	if (locale === "da") return da_deep_match_select_both(inputs)
	if (locale === "sv") return sv_deep_match_select_both(inputs)
	return en_deep_match_select_both(inputs)
});